import { render, staticRenderFns } from "./fulfillment-table.vue?vue&type=template&id=20947208"
import script from "./fulfillment-table.vue?vue&type=script&lang=js"
export * from "./fulfillment-table.vue?vue&type=script&lang=js"
import style0 from "./fulfillment-table.vue?vue&type=style&index=0&id=20947208&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports